module.exports = __webpack_public_path__ + "img/ipad-frame-landscape.1f03e19.png";